import { Badge, Card, SimpleGrid, Stack, Text, Title } from '@cowbell/ui/core';
import { format } from 'date-fns';
import getSeverityColor from './getSeverityColor';
import { getStatusConfig } from '../utils';
import { SpotlightStatus } from './spotlightDetails.types';
import { formatSeverityForDisplay } from '../TabbedReasonsRecommendations';

interface SpotlightDetailsMetadataCardProps {
  dataSource: string;
  mostImpactedCF: string;
  importance: string;
  created: string;
  status?: SpotlightStatus;
}

export function SpotlightDetailsMetadataCard(
  props: SpotlightDetailsMetadataCardProps
) {
  const { dataSource, mostImpactedCF, importance, created, status } = props;

  const statusConfig = getStatusConfig(status);

  return (
    <Card mt="md" padding="lg" shadow="sm" radius="md">
      <Title order={3} mb="md">
        Spotlight Details
      </Title>
      <SimpleGrid cols={{ base: 1, sm: 2, md: 5 }} spacing="lg">
        <Stack gap="xs">
          <Text size="sm" fw={600} c="dimmed" tt="uppercase">
            Data Source
          </Text>
          <Text size="md" fw={400}>
            {dataSource}
          </Text>
        </Stack>
        <Stack gap="xs">
          <Text size="sm" fw={600} c="dimmed" tt="uppercase">
            Most Impacted CFS
          </Text>
          <Text size="md" fw={400}>
            {mostImpactedCF}
          </Text>
        </Stack>
        <Stack gap="xs">
          <Text size="sm" fw={600} c="dimmed" tt="uppercase">
            Severity
          </Text>
          <Badge
            color={getSeverityColor(importance)}
            variant="outline"
            size="lg"
            radius="sm"
          >
            {formatSeverityForDisplay(importance)}
          </Badge>
        </Stack>
        <Stack gap="xs">
          <Text size="sm" fw={600} c="dimmed" tt="uppercase">
            Date
          </Text>
          <Text size="md" fw={400}>
            {format(new Date(created), 'MM/dd/yyyy')}
          </Text>
        </Stack>
        <Stack gap="xs">
          <Text size="sm" fw={600} c="dimmed" tt="uppercase">
            Status
          </Text>
          {statusConfig && (
            <Badge
              size="lg"
              radius="sm"
              variant="outline"
              color={statusConfig.color}
            >
              {statusConfig.label}
            </Badge>
          )}
        </Stack>
      </SimpleGrid>
    </Card>
  );
}
